import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom'
import { CambiarClaveContentPanel } from './CambiarClaveContentPanel';
import AuthService from '../../services/AuthService.js' 

export class CambiarClaveForm extends Component {
    constructor(props) {
        super(props);

        var redirect = false;

        this.state = { 
            redirect: redirect 
        };
         
        //events
        this.onSubmit = this.onSubmit.bind(this);
        this.buttonCancel_onClick = this.buttonCancel_onClick.bind(this);
    }
    componentDidMount() { 
    } 
    buttonCancel_onClick() {
        //this.props.history.push('/');
    } 
    onSubmit(e) {
        var me = this;
        e.preventDefault();
        const data = new FormData(e.target);
        fetch('api/Sesion/CambiarClave', {
            method: 'POST',
            body: data
        })
            .then(function (response) {
                var x = 0;
                x++;
                if (response.ok) {
                    return response.json();
                }
                else {
                    return response.json();
                }
            })
            .then(function (result) {
                var x = 0;
                x++;
                if (result.error) {
                    alert(result.error);
                } else {
                    alert(result.message);
                    me.setState({
                        redirect: true
                    });
                }
            })
            .catch(function (err) {
                var x = 0;
                x++;
                alert(err);
            });
    }

    render() {
        if (this.state.redirect) {
            return (<Redirect to={"/home"} />);
        }
        return (
            <div>
                <h4>Cambiar contraseña</h4>
                <form id="LoginForm" onSubmit={this.onSubmit}>
                    <div>
                        <CambiarClaveContentPanel />
                    </div>
                    <div className="btn-group" role="group" aria-label="...">
                        <button type="submit" className="btn btn-primary btn-sm">Aceptar</button>
                    </div>
                </form>
            </div >
        );
    }
}
